import styled from 'theme';

export const FormLinkRegister = styled.div`
  width: 100%;
  display: block;
  margin-top: 1rem;
  margin-bottom: 1rem;
  text-align: right;

  span {
    color: ${props => props.theme.variables.colors.red};
    font-weight: ${props => props.theme.variables.fonts.weight.light};
    cursor: pointer;
    font-size: 0.85rem;

    &:hover {
      color: ${props => props.theme.variables.colors.darkRed};
    }

    &:not(:last-child) {
      margin-bottom: 0.5rem;
    }
  }
`;

export const FormLinkResetPassword = styled.div`
  width: 100%;
  display: block;
  text-align: right;
  margin-top: -1.5rem;
  margin-bottom: 1rem;

  span {
    color: ${props => props.theme.variables.colors.red};
    font-size: 0.75rem;
    font-weight: ${props => props.theme.variables.fonts.weight.light};
    cursor: pointer;

    &:hover {
      color: ${props => props.theme.variables.colors.darkRed};
    }
  }
`;
